import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = { class: "p-2" }

import PersonalTable from '@/components/PersonalTable.vue'
    import Api from '@/services/api'
    import { onBeforeMount } from 'vue'
    import { ref } from 'vue';
    import { ElMessageBox } from 'element-plus';
    import { useStore } from 'vuex';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'UsersView',
  setup(__props) {

    const loading = ref<boolean>(true)
    const data = ref<Array<unknown>>()

    const getSellers = async () => {
        const res = await Api.get('admin/users')
        if (res.status == 200) {
            data.value = res.data.users
        } else {
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
        }
    }
    onBeforeMount(async () => {
        await getSellers()
        loading.value = false
    })

    const store = useStore()
    store.watch((s, g) => g.openModal, async (val, oldVal) => {
        if (oldVal == 1) {
            await getSellers()
        }
    })

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { header: "Entregadores e administradores da Beasy" }, {
      default: _withCtx(() => [
        _createVNode(PersonalTable, {
          loading: loading.value,
          height: 450,
          showRows: 10,
          cols: [
                // {label: 'Cod', prop: 'id'},
                // {label: 'cargo', prop: 'role'},
                {label: 'Nome', prop: 'name'},
                {label: 'Bairo', prop: 'location'},
                {label: 'Telefone', prop: 'phone'},
            ],
          data: data.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "Cadastrado por",
              "class-name": "auto",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createTextVNode(_toDisplayString(data.row.user.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Cargo",
              "class-name": "auto",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createTextVNode(_toDisplayString(data.row.role == 'seller' ? 'Entregador':'Administrador'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Cadatrado em",
              "class-name": "auto",
              "min-width": 100
            }, {
              default: _withCtx((data) => [
                _createTextVNode(_toDisplayString(new Date(data.row.created_at).toLocaleString()), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Acções",
              "class-name": "auto"
            }, {
              default: _withCtx((data) => [
                _createElementVNode("span", _hoisted_2, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    tag: "router-link",
                    to: '/users/' + data.row.id,
                    icon: "View",
                    title: "Ver mais"
                  }, null, 8, ["to"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading", "data"])
      ]),
      _: 1
    })
  ]))
}
}

})